import { ProviderType } from '../../api';
import type { RosterTypeCounts } from './roster.types';

/** The provider types the design gives a chip, in its order. */
export const ROSTER_DESIGN_PROVIDER_TYPES: ProviderType[] = [
    ProviderType.BILLING,
    ProviderType.RENDERING,
    ProviderType.REFERRING,
    ProviderType.SUPERVISING,
    ProviderType.ORDERING,
];

/**
 * The type chips to show: the design's five always, then any other type that has providers.
 *
 * `ProviderType` has nine values and the design draws five. Hiding the other four outright would
 * make an ATTENDING provider unfindable by type; showing all nine would fill the bar with chips
 * reading 0. A type that exists in the data earns a chip. Until counts load, only the design's five
 * are shown.
 */
export function rosterProviderTypeChips(counts: RosterTypeCounts | undefined): ProviderType[] {
    const extra = (Object.values(ProviderType) as ProviderType[]).filter(
        type => !ROSTER_DESIGN_PROVIDER_TYPES.includes(type) && (counts?.byType[type] ?? 0) > 0,
    );
    return [...ROSTER_DESIGN_PROVIDER_TYPES, ...extra];
}
